export default class Storage {
    static init() {
        try {
            localStorage.setItem("i2i-test", 1);
            localStorage.removeItem("i2i-test");

            this.storageType = localStorage;
        } catch (err) {
            
            console.error(err);
            this.storageType = localStorage;
        }
    }

    static setItem(key, value) {
        this.storageType.setItem(key, value);
    }

    static getItem(key: string) {
        return this.storageType.getItem(key);
    }

    static removeItem(key) {
        this.storageType.removeItem(key);
    }

    static clear() {
        this.storageType?.clear();
    }
}

Storage.init();
